import { cn } from "../lib/utils.js";
import { Skeleton } from "../components/skeleton.js";
import { Avatar, AvatarSkeleton } from "../components/avatar.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/smart-components/userInfo.tsx
const textSizeStyles = {
	xs: {
		name: "tw:new:text-xs",
		secondary: "tw:new:text-xs tw:text-xs"
	},
	sm: {
		name: "tw:new:text-xs",
		secondary: "tw:new:text-xs tw:text-xs"
	},
	md: {
		name: "tw:new:text-sm",
		secondary: "tw:new:text-sm tw:text-sm"
	},
	lg: {
		name: "tw:new:text-lg",
		secondary: "tw:new:text-base tw:text-base"
	},
	xl: {
		name: "tw:new:text-xl",
		secondary: "tw:new:text-lg tw:text-lg"
	}
};
const UserInfo = ({ full_name, initialsFrom, secondary, imageUrl, secondaryClassName, nameClassName, nameSuffix, size = "md", className, avatar }) => {
	const initialsSource = initialsFrom || full_name;
	const nameParts = initialsSource?.split(" ") ?? [];
	const initials = nameParts.length >= 2 ? `${nameParts[0]?.[0] ?? ""}${nameParts[1]?.[0] ?? ""}` : initialsSource?.slice(0, 2) ?? "";
	const textStyles = textSizeStyles[size];
	return /* @__PURE__ */ jsxs("div", {
		className: cn("tw:flex tw:gap-3", className),
		children: [avatar ?? /* @__PURE__ */ jsx("div", {
			className: "tw:rounded-sm tw:font-semibold",
			children: /* @__PURE__ */ jsx(Avatar, {
				initials: initials.toUpperCase(),
				size,
				imageUrl
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "tw:flex tw:flex-1 tw:min-w-0 tw:flex-col tw:justify-center",
			children: [nameSuffix ? /* @__PURE__ */ jsxs("div", {
				className: "tw:flex tw:min-w-0 tw:items-center tw:gap-1.5",
				children: [/* @__PURE__ */ jsx("div", {
					className: cn(textStyles.name, "tw:new:font-semibold tw:new:text-midnight", nameClassName),
					children: full_name
				}), nameSuffix]
			}) : /* @__PURE__ */ jsx("div", {
				className: cn(textStyles.name, "tw:new:font-semibold tw:new:text-midnight", nameClassName),
				children: full_name
			}), secondary && /* @__PURE__ */ jsx("div", {
				className: cn(textStyles.secondary, "tw:new:text-muted-foreground tw:text-muted-foreground tw:truncate", secondaryClassName),
				children: secondary
			})]
		})]
	});
};
const nameSkeletonStyles = {
	xs: "tw:h-3 tw:w-20",
	sm: "tw:h-3 tw:w-24",
	md: "tw:h-4 tw:w-36",
	lg: "tw:h-5 tw:w-40",
	xl: "tw:h-6 tw:w-44"
};
const secondarySkeletonStyles = {
	xs: "tw:h-3 tw:w-16",
	sm: "tw:h-3 tw:w-20",
	md: "tw:h-3.5 tw:w-28",
	lg: "tw:h-4 tw:w-32",
	xl: "tw:h-5 tw:w-36"
};
const UserInfoSkeleton = ({ size = "md", className, showSecondary = true }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: cn("tw:flex tw:gap-3", className),
		children: [/* @__PURE__ */ jsx("div", {
			className: "tw:rounded-sm",
			children: /* @__PURE__ */ jsx(AvatarSkeleton, { size })
		}), /* @__PURE__ */ jsxs("div", {
			className: "tw:flex tw:flex-1 tw:min-w-0 tw:flex-col tw:justify-center tw:gap-1.5",
			children: [/* @__PURE__ */ jsx(Skeleton, { className: nameSkeletonStyles[size] }), showSecondary && /* @__PURE__ */ jsx(Skeleton, { className: secondarySkeletonStyles[size] })]
		})]
	});
};
//#endregion
export { UserInfo, UserInfoSkeleton };

//# sourceMappingURL=userInfo.js.map